"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventTransition = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
exports.PreventTransition = react_1.default.memo(function (_a) {
    var isBlocked = _a.isBlocked, _b = _a.shouldPreventTransition, shouldPreventTransition = _b === void 0 ? function () { return true; } : _b, children = _a.children;
    var _c = (0, react_1.useState)(null), blockedTransition = _c[0], setBlockedTransition = _c[1];
    var history = (0, react_router_dom_1.useHistory)();
    var allowTransition = function (next) {
        if (isBlocked) {
            // allows for forcing a transition if we need to for user timeout and etc
            if (shouldPreventTransition(next)) {
                setBlockedTransition(next);
                return false;
            }
        }
        // reset state in case this component stays mounted
        setBlockedTransition(null);
        return true;
    };
    (0, react_1.useEffect)(function () {
        if (blockedTransition && !isBlocked) {
            history.push(blockedTransition);
        }
    }, [blockedTransition, isBlocked, history]);
    var onCancel = (0, react_1.useCallback)(function () {
        setBlockedTransition(null);
    }, [setBlockedTransition]);
    return isBlocked ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Prompt, { when: isBlocked, message: allowTransition }), blockedTransition &&
                children({
                    onCancel: onCancel,
                })] })) : null;
});
